// extracted by mini-css-extract-plugin
module.exports = {"App":"reset-password_App__1Ga6M","Card":"reset-password_Card__39cJ-"};